import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

export async function getsuperAdminDashboardUserDetails(StartDate, EndDate) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  let UserCompanyId = await localStorage.getItem("UserCompanyId");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminDashboardUserDetails?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
export async function getsuperAdminQrCodeAndScanSttWallet(StartDate, EndDate) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  let UserCompanyId = await localStorage.getItem("UserCompanyId");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminQrCodeAndScanSttWallet?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getsuperAdminSalesDetail(StartDate, EndDate) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  let UserCompanyId = await localStorage.getItem("UserCompanyId");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminSalesDetail?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getCountryWiseSalesDetail(StartDate, EndDate) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/GetCountryWiseSalesDetail?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getsuperAdminQrcodecountrywiseDetail(StartDate, EndDate) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminQrCodeCountryWiseDetail?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getsuperAdminScancountrywiseDetail(StartDate, EndDate) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminCountryWiseScanDetail?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getsuperAdminQrcodeSavedcountrywiseDetail(
  StartDate,
  EndDate
) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminCountryWiseScanSavedDetail?StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getsuperAdminUserPackageBycountryDetails(
  packageID,
  StartDate,
  EndDate
) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/SuperAdminPackageIDByCountryDetailAndUser?PackageID=" +
      packageID +
      "&StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getsuperAdmincountryIDbyUserDetails(
  packageID,
  countryId,
  StartDate,
  EndDate
) {
  let Auth0token = await localStorage.getItem("Auth0token");
  let loginid = await localStorage.getItem("loginUserID");
  return fetch(
    Config.apiUrl +
      "SuperAdmin/GetUserDetailbyCountryIdAndPackageId?PackageID=" +
      packageID +
      "&CountryId=" +
      countryId +
      "&StartDate=" +
      StartDate +
      "&EndDate=" +
      EndDate,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
